import React, { useState, useEffect, useCallback } from "react";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";
import { replaceHrefInAnswer } from "./SignupUrlReplacer.js";

const generateCardLines = (lineCount) => {
  const lines = [];
  const totalLines = lineCount;
  const lineHeightPercentage = 38;

  for (let i = 0; i < totalLines; i++) {
    const topPercentage = (i + 2) * lineHeightPercentage;
    const lineStyle = {
      border: `0.1px solid ${colors.primitive.grey[800]}`,
      opacity: 0.1,
      position: "absolute",
      width: "100%",
      top: `${topPercentage}px`,
    };

    lines.push(<div className="card-line" key={i} style={lineStyle}></div>);
  }
  return lines;
};
function CalendarCard({ data, index, lineCount }) {
  return (
    <a className={`white-card`} href={data.cardURL}>
      <div className="card-top-margin"></div>
      <div className="margin-line"></div>
      <div className="dotted-line"></div>
      {generateCardLines(lineCount)}
      <div className="card-content">
        <p className="cardHeading">{data.cardHeading}</p>
        <p
          dangerouslySetInnerHTML={{ __html: data.cardDesc }}
          className="mt-2"
        ></p>
      </div>
      <style jsx>{`
        .white-card {
          background: ${colors.primitive.white.default};
          border-radius: 8px;
          box-shadow: 0px 1px 2px 0px #303a4733;
          width: 260px;
          height: 258px;
          position: relative;
          cursor: pointer;
          overflow: hidden;
        }
        .white-card:hover {
          box-shadow: 0px 8px 24px 0px rgba(140, 149, 159, 0.2);
        }
        .white-card:hover .card-top-margin {
          background: ${colors.primitive.blue[200]};
          transition: all 0.3s ease-in;
        }
        .card-top-margin {
          height: 25px;
          background-color: ${colors.primitive.grey[1700]};
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;
        }
        .margin-line {
          width: 1px;
          height: 100%;
          background-color: ${colors.primitive.red[400]};
          position: absolute;
          left: 15px;
          opacity: 0.5;
        }
        .dotted-line {
          border: 3px dotted ${colors.primitive.grey[800]};
          border-bottom: none;
          opacity: 0.1;
          margin-top: 10px;
          position: absolute;
          width: 100%;
          margin-bottom: 30px;
        }
        .card-content {
          padding: 18px 24px 32px 32px;
        }
        .cardHeading {
          color: ${colors.primitive.blue[700]};
          font-weight: bold;
          font-size: ${font.size.md[2]};
          line-height: ${lineHeight[7]};
        }
        .item-${index} {
          order: ${index};
        }
      `}</style>
    </a>
  );
}

export const ResultsContainer = ({ data }) => {
  return (
    <section
      className="bg-light-blue-grey lg:-mt-10 lg:pt-20 lg:pb-19 md:pb-5 md:pt-7"
      id="results-container"
    >
      <div
        className="list-section cards container search-results fx"
        id="results"
      >
        {data.map((item, index) => (
          <CalendarCard data={item} index={index} key={index} />
        ))}
      </div>
    </section>
  );
};

export function Dots(data, order) {
  const [activeIndex, setActiveIndex] = useState(0);
  const updateTransform = useCallback(
    (index) => {
      const cardSize = document.querySelector(".white-card").offsetWidth;
      const getContainer = document.getElementById(`cardContainer-${order}`);
      const cardWidth = cardSize + 20;
      const translateX = -index * cardWidth;
      if (getContainer !== null) {
        getContainer.style.transform = `translateX(${translateX}px)`;
      }
    },
    [order]
  );
  useEffect(() => {
    const isMobile = window.innerWidth < 576;
    if (isMobile) {
      const intervalId = setInterval(() => {
        const newIndex = (activeIndex + 1) % data.length;
        setActiveIndex(newIndex);
        updateTransform(newIndex);
      }, 4000);

      return () => clearInterval(intervalId);
    }
  }, [activeIndex, data, updateTransform]);

  function handleDotClick(index) {
    setActiveIndex(index);
    updateTransform(index);
  }

  return (
    <>
      {Array.isArray(data) && (
        <div className="dots">
          {data.map((_, index) => (
            <span
              key={index}
              className={index === activeIndex ? "active" : ""}
              onClick={() => handleDotClick(index)}
            />
          ))}
        </div>
      )}
      <style jsx>{`
   @media (max-width: ${viewport.mobile.md}) {
    .dots {
      display: flex;
      justify-content: center;
      margin-right: 20px;
      margin-top:10px;
    }
    .dots span {
      width: 8px;
      height: 8px;
      background-color: #ccc;
      border-radius: 50%;
      margin: 0 7px;
      cursor: pointer;
    }
    .dots span.active {
      background-color: ${colors.primitive.blue[200]};
    }
  }
        }
        `}</style>
    </>
  );
}
export default function CalendarCardSection({ data, lineCount }) {
  return (
    <>
      {Array.isArray(data) &&
        data.map((item, index) =>
          item.hasOwnProperty("isInfoCard") ? (
            <div key={index} className="info-card white-card card-content">
              <p
                dangerouslySetInnerHTML={{
                  __html: replaceHrefInAnswer(item.cardDesc),
                }}
              ></p>
            </div>
          ) : (
            <CalendarCard
              data={item}
              key={index}
              index={index}
              lineCount={lineCount}
            />
          )
        )}
    </>
  );
}
